<template>
  <v-app light>
    <v-navigation-drawer fixed app right temporary floating light v-model="sideNav" class="pb-0">
      <v-container grid-list-xl text-xs-center fill-height>
        <v-layout row wrap align-content-space-between>
            <v-flex xs12>
              <v-list>
                <v-list-tile v-for="item in menuItems" 
                  :key="item.title" 
                  router 
                  :to="item.link">
                  <v-list-tile-action>
                      <v-icon right>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    {{ item.title }}
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile class="trialButton cyan darken-2" v-if="userIsAuthenticate"
                  router 
                  :to="'/trial/new'"
                  color="cyan darken-2" dark>
                  <v-list-tile-action class="white--text">
                      <v-icon left class="white--text">add</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content class="white--text">
                      New Trial
                  </v-list-tile-content>
                </v-list-tile>
                
                <v-list-tile v-if="userIsAuthenticate"
                  router 
                  :to="'/alert/new'"
                  flat>
                  <v-list-tile-action>
                      <v-icon left>add</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    Update Alert
                  </v-list-tile-content>
                </v-list-tile>
                
                <template v-if="!userIsAuthenticate">
                  <app-edit-menu-login-dialog></app-edit-menu-login-dialog>
                </template>                          																										

              </v-list>
            </v-flex>
            <v-flex xs12>
              <v-list>
                <v-list-tile v-if="userIsAuthenticate"
                  @click="onLogout"
                  flat>
                  <v-list-tile-action>
                      <v-icon left>exit_to_app</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    Log Out
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
        </v-layout> 
      </v-container>     
    </v-navigation-drawer>
    <v-toolbar fixed dark class="primary cyan darken-1">
      <div style="width: 52px;" right><a @click="$router.go(-1)" v-if="!checkLocations"><v-icon>keyboard_arrow_left</v-icon></a></div>
      <div center class="justify-center" style="width: 100%; text-align: center;">
        <router-link :to="menuItems[0].link" tag="span" style="cursor: pointer"><v-icon>home</v-icon></router-link>
      </div>
      <div right><v-toolbar-side-icon class="hidden-xl-and-up mr-0" @click="sideNav = !sideNav"></v-toolbar-side-icon></div>
      <v-spacer></v-spacer>
      <!-- <v-toolbar-items class="hidden-lg-and-down">
        <v-btn flat 
          v-for="item in menuItems" 
          :key="item.title" 
          :to="item.link">
          <v-icon left>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
        <v-btn 
          v-if="userIsAuthenticate"
          @click="onLogout"
          flat>
          <v-icon left>exit_to_app</v-icon>
          Log Out
        </v-btn>
      </v-toolbar-items> -->
      <v-toolbar-items right style="">
<!--        <v-btn flat 
          v-for="item in addNew" 
          :key="item.title" 
          :to="item.link">
          <v-icon left>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
        <v-btn 
          v-if="userIsAuthenticate"
          @click="onLogout"
          flat>
          <v-icon left>exit_to_app</v-icon>
          Log Out
        </v-btn>  -->

<!--        <v-btn flat v-if="checkLocation && userIsAuthenticate" @click="pageLocation">
          <v-icon>add</v-icon>
        </v-btn> -->
<!--
        <template v-if="!userIsAuthenticate">
          <v-spacer></v-spacer>
          <app-edit-login-dialog></app-edit-login-dialog>
        </template>     
-->                             																										
      </v-toolbar-items>
    </v-toolbar>


    <!-- <div class="alert" v-if="loadedNotice && checkLocations">
      <v-btn block color="cyan darken-2" @click.native="snackbar = true" dark>See Trial Alert</v-btn>            
    </div> -->
    <main class="white">
      <router-view class="white"></router-view>            
    </main>
    <footer>
      <!-- <div
        v-if="loadedNotice">
        <v-snackbar
          :timeout="timeout"
          :color="color"
          multi-line
          top
          vertical
          v-model="snackbar"
        >
          {{ loadedNotice.noticeName }}      
          <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
        </v-snackbar>
      </div> -->
      <v-container class="mt-0">
        <v-layout row>
          <v-flex class="text-xs-center mb-4">
            <span class="white--text">Copyright 2018 Victorium Clinical Reseah, LLC.</span>
          </v-flex>
        </v-layout>
      </v-container>
    </footer>
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        sideNav: false,
        addNew: false,
        snackbar: false,
        alert: true,
        absolute: false,
        color: 'cyan darken-2',
        timeout: 6000,
        text: ''
      }
    },
    computed: {
      menuItems () {
        let menuItems = [
//          { icon: 'navigate_before', title: 'Back', link: '' },
          { icon: 'home', title: 'Home', link: '/' },
          { icon: 'face', title: 'Sign Up', link: '/signup' },
//          { icon: 'lock_open', title: 'Sign In', link: '/signin' },
          { icon: 'view_list', title: 'Trials', link: '/trials' }
        ]
        if (this.userIsAuthenticate) {
          menuItems = [
            { icon: 'home', title: 'Home', link: '/' },
//            { icon: 'person', title: 'Profile', link: '/profile' },
            { icon: 'view_list', title: 'Trials', link: '/trials' },
//            { icon: 'add', title: 'New Trial', link: '/trial/new' },
            { icon: 'view_list', title: 'Locations', link: '/locations' },
//            { icon: 'add', title: 'New Location', link: '/location/new' },
            { icon: 'view_list', title: 'Indications', link: '/indications' },
//            { icon: 'add', title: 'New Indication', link: '/indication/new' },
            { icon: 'view_list', title: 'Investigators', link: '/investigators' },
//            { icon: 'add', title: 'New Investigator', link: '/investigator/new' },
            { icon: 'view_list', title: 'Coordinator', link: '/coordinators' }
//            { icon: 'add', title: 'New Coordinator', link: '/coordinator/new' }
          ]
        }
        return menuItems
      },
      userIsAuthenticate () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      },
      checkLocation () {
        var currentRoute = this.$route.path
        var singleTrial = '/trials/'
        if (this.$route.path === '/Trials/Locations' || this.$route.path === '/Trials/Indications' || this.$route.path === '/Trials/Coordinators' || this.$route.path === '/Trials/Investigators' || currentRoute.startsWith(singleTrial)) {
          return !this.addnew
        }
        return
      },
      checkLocations () {
        if (this.$route.path === '/') {
          return true
        }
        return
      }
    },
    methods: {
      onLogout () {
        this.$store.dispatch('logout')
      },
      pageLocation () {
        console.log('The path is: ' + this.$route.path)
        var currentRoute = this.$route.path
        var singleTrial = '/trials/'
        if (currentRoute === '/Trials/Locations') {
          this.$router.push('/location/new')
        }
        if (currentRoute === '/Trials/Locations') {
          this.$router.push('/location/new')
        }
        if (currentRoute === '/Trials/Indications') {
          this.$router.push('/indication/new')
        }
        if (currentRoute === '/Trials/Coordinators') {
          this.$router.push('/coordinator/new')
        }
        if (currentRoute === '/Trials/Investigators') {
          this.$router.push('/investigator/new')
        }
        if (currentRoute.startsWith(singleTrial)) {
          this.$router.push('/trial/new')
        }
      }
    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'
</style>

<style lang="scss">
  main{
    padding-top: 66px;
  }
  body{
    background-color: #fff;
  }
  h1, h2, h3{
    text-transform: uppercase;
  }
  .alt{
    background: #eaf6f8 !important;
    color: #2fa4c0 !important;
    text-transform: uppercase;
  }
  form{
    input{
      // border: 1px solid #e3e3e3;
      border-radius: 3px;
      &:focus{
        border-left: 2px solid #2fa4c0;
        border-bottom: 2px solid #c4e4ec;
        color: #2fa4c0;
        background: #eaf6f8;
      }
    }
  }
  .alert{
    // padding-top: 64px;
    margin-bottom: 1rem;
    &.alert{
      border-color: transparent !important;
    }
    button{
      max-width: 300px;
      margin: 0 auto;
    }
  }
  .trialButton{
    
  }
  .info{
    box-shadow: none;
  }
  .list.listItems{
    padding: 0;
    li{
      box-shadow: none;
      border-left: 2px solid #fff;
      border-bottom: 2px solid #e3e3e3;
      .list__tile{
        padding-right: 0;
        padding-left: 0;
        .avatar{
          width: 36px !important;
          min-width: 36px !important;
        }
      }
      @media screen and (min-width: 480px){
        &:hover{
          background: #eaf6f8;
          border-left: 2px solid #2fa4c0;
          border-bottom: 2px solid #c4e4ec;
          .list__tile__title{
            color: #2fa4c0;
            font-weight: bold;
          }
        }        
      }
      .list__tile__action{
        min-height: 66px;
      }
    }
  }

  // Vuetify Expansion Panel Edits
  .expansion-panel{
    box-shadow: none;
  }
  .expansion-panel__header, .header{
    background: #c1e3ec !important;
    border-bottom: 1px solid #a6d7e2;
    color: #2fa4c0;
    font-weight: bold;
    text-transform: uppercase;
    padding: 12px;
    .header__icon{
      i{
        color: #2fa4c0 !important;
      }
    }
  }
  .trialData{
    *{
      text-align: left;
    }
    .header{
      margin-top: .5rem;
      &:first-child{
      }
    }
  }

  .editDialogsRow{
    background: #eaf6f8;
    width: 100%;
    .icon{
      color: #c1e3ec;
      float: right;
    }
    .card__text{
      border-bottom: none !important;
    }
  }
// Footer
  footer{
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#2fa4c0+22,009abc+41,1c315a+100 */
    background: #2fa4c0; /* Old browsers */
    background: -moz-linear-gradient(top, #2fa4c0 22%, #009abc 41%, #1c315a 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, #2fa4c0 22%,#009abc 41%,#1c315a 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, #2fa4c0 22%,#009abc 41%,#1c315a 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2fa4c0', endColorstr='#1c315a',GradientType=0 ); /* IE6-9 */
  }
</style>



// WEBPACK FOOTER //
// App.vue?d5c8e4aa